"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT_INFO_FONT_WEIGHT = exports.TEXT_INFO_SIZE = exports.TEXT_INFO_HEADING_LEVEL = exports.TEXT_INFO_ALIGN = exports.TEXT_INFO_COLOR = exports.TEXT_INFO_DECORATION = exports.TEXT_INFO_BORDER = exports.TEXT_INFO_SEGMENT = exports.TEXT_INFO_DISPLAY = exports.TEXT_INFO_KIND = void 0;
exports.TEXT_INFO_KIND = {
    HEADING: 'heading',
    PARAGRAPH: 'paragraph',
    SPAN: 'span',
};
exports.TEXT_INFO_DISPLAY = {
    INLINE: 'inline',
    BLOCK: 'block',
    DEFAULT: 'default',
};
exports.TEXT_INFO_SEGMENT = {
    PARTICULARES: 'particulares',
    GP: 'gp',
    EMP: 'emp',
    EMPRESAS: 'empresas',
    PLUS: 'plus',
};
exports.TEXT_INFO_BORDER = {
    NONE: 'none',
    ROUNDED: 'rounded',
};
exports.TEXT_INFO_DECORATION = {
    LINE_THROUGH: 'linethrough',
    UNDERLINE: 'underline',
    NONE: 'none',
};
exports.TEXT_INFO_COLOR = {
    TRANPARENT: 'transparent',
    BLACK: 'black',
    WHITE: 'white',
    GREEN: 'green',
    GREEN_LIGHT: 'green-light',
    GREEN_DARK: 'green-dark',
    COOL_GREY: 'cool-grey',
    GREY_9: 'grey9',
    GREY_8: 'grey8',
    GREY_7: 'grey7',
    GREY_6: 'grey6',
    GREY_5: 'grey5',
    GREY_5B: 'grey5b',
    GREY_4: 'grey4',
    GREY_4A: 'grey4a',
    GREY_3: 'grey3',
    GREY_2: 'grey2',
    GREY_1: 'grey1',
    GREY_1A: 'grey1a',
    GREY_A: 'greya',
    GREY_0: 'grey0',
    ORANGE: 'orange',
    ORANGE_MEDIUM: 'orange-medium',
    ORANGE_LIGHT: 'orange-light',
    ORANGE_DARK: 'orange-dark',
    EGG: 'egg',
    EGG_LIGHT: 'egg-light',
    EGG_DARK: 'egg-dark',
    BLUE: 'blue',
    BLUE_A: 'blue-a',
    BLUE_MEDIUM: 'blue-medium',
    BLUE_LIGHT: 'blue-light',
    BLUE_DARK: 'blue-dark',
    BLUE_DARK1: 'blue-dark1',
    PURPLE: 'purple',
    PURPLE_LIGHT: 'purple-light',
    PURPLE_DARK: 'purple-dark',
    PINK: 'pink',
    PINK_LIGHT: 'pink-light',
    PINK_DARK: 'pink-dark',
    PIPPER: 'pipper',
    PIPPER_LIGHT: 'pipper-light',
    PIPPER_DARK: 'pipper-dark',
    RED: 'red',
    RED_LIGHT: 'red-light',
    RED_DARK: 'red-dark',
    CORAL: 'coral',
    CORAL_LIGHT: 'coral-light',
    CORAL_DARK: 'coral-dark',
    ORCHID_DARK: 'orchid-dark',
    TURQUOISE_LIGHT: 'turquoise-light',
};
exports.TEXT_INFO_ALIGN = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
    JUSTIFY: 'justify',
};
exports.TEXT_INFO_HEADING_LEVEL = {
    H1: 1,
    H2: 2,
    H3: 3,
    H4: 4,
    H5: 5,
    H6: 6,
};
exports.TEXT_INFO_SIZE = {
    TITLE1: 'title01',
    TITLE2: 'title02',
    TITLE3: 'title03',
    TITLE4: 'title04',
    TITLE45: 'title045',
    TITLE5: 'title05',
    TITLE6: 'title06',
    TITLE7: 'title07',
    DISPLAY1: 'display01',
    DISPLAY2: 'display02',
    DISPLAY3: 'display03',
    CAPTION1: 'caption01',
    CAPTION2: 'caption02',
    CAPTION3: 'caption03',
};
exports.TEXT_INFO_FONT_WEIGHT = {
    REGULAR: 'font-regular',
    LIGHT: 'font-light',
    BOLD: 'font-bold',
};
//# sourceMappingURL=enums.js.map